import { useContext, type ReactNode } from 'react';

import { Stack } from '@mui/material';

import { Pill, Segment } from '@/designs-dev/inspect/Pill';
import { ConceptTag } from '@/designs-dev/loft/conceptTag';

// The bar every prototype floats at the foot of its stage, the way Figma's
// prototype view keeps its controls and the way a flows page's canvas does:
// what the page is (a concept), how you are looking at it (DrillModeToggle,
// which carries comments), then what it is showing (StateSelectors and the
// like, passed as children).
//
// Floats over the stage, so the stage needs `position: 'relative'` and room
// below its screen: `pb: STAGE_BAR_ROOM`. One row, always: where the stage is
// narrower than the pills (a phone, or a laptop with the drill panels open)
// it scrolls sideways rather than wrapping.
export const STAGE_BAR_ROOM = 12;

const StageBar = ({ children }: { children: ReactNode }) => {
  const concept = useContext(ConceptTag);
  return (
    <Stack
      sx={{
        position: 'absolute',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2,
        alignItems: 'center',
        maxWidth: 'calc(100% - 32px)',
        overflowX: 'auto',
        scrollbarWidth: 'none',
        '&::-webkit-scrollbar': { display: 'none' },
        '& > *': { flexShrink: 0 },
      }}
      direction='row'
      spacing={1}
    >
      {/* Which concept, so an exploration is never mistaken for a version. */}
      {concept && (
        <Pill>
          <Segment label='Concept'>{concept}</Segment>
        </Pill>
      )}
      {children}
    </Stack>
  );
};

export default StageBar;
